import { useInvestorMenu } from "features/investors/InvestorMenu";
import { InvestorTabProps } from "features/investors/InvestorTabProps";
import { useInvestorRetrieveSuspense } from "gen/endpoints/investor/investor";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Restricted } from "shared/components/access/Restricted";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageMenu } from "shared/components/layout/PageMenu";
import { PageTabs } from "shared/components/layout/PageTabs";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";
import { useCurrentPageTabId } from "shared/navigation/useCurrentPageTabId";

export const InvestorPage: React.FC = () => {
  const { t } = useTranslation([
    "commitment",
    "common",
    "investor",
    "investorEntity",
  ]);
  const navigate = useNavigate();
  const { investorId } = useRequiredStringParams();
  const currentPageTabId = useCurrentPageTabId();

  const { data: investor } = useInvestorRetrieveSuspense(investorId);

  const {
    getMenuItems,
    openCreateInvestorEntityModal,
    openAddExistingInvestorEntityModal,
    openDeleteInvestorEntityRelationshipsModal,
  } = useInvestorMenu({
    onDelete: () => {
      navigate(rootRoute({}).investors({}).$);
    },
  });

  const tabProps: InvestorTabProps = {
    investorId,
    openCreateInvestorEntityModal: () =>
      openCreateInvestorEntityModal({ investorId }),
    openAddExistingInvestorEntityModal: () =>
      openAddExistingInvestorEntityModal({ investorId }),
    openDeleteInvestorEntityRelationshipsModal: () =>
      openDeleteInvestorEntityRelationshipsModal({ investorId }),
  };

  return (
    <PageContent
      contentWidth="wide"
      isFullHeight={currentPageTabId !== "investorsInvestorProfile"}
    >
      <PageHeader
        title={investor.name}
        backButton={{
          title: t("common:investors"),
          path: rootRoute({}).investors({}).$,
        }}
        actions={
          <Restricted permission={PermissionTypeEnum.config}>
            <PageMenu>{getMenuItems({ investorId })}</PageMenu>
          </Restricted>
        }
      />
      <PageBody>
        <PageTabs context={tabProps} />
      </PageBody>
    </PageContent>
  );
};
